import { useLocation } from "react-router-dom";
import { Clock, Mail, MapPin, MessageCircle, Navigation, Phone, Star } from "lucide-react";

export const MAPS_URL = "https://www.google.com/maps/place/Sobrino+Sport/@37.3550082,-2.2987611,17z/data=!3m1!4b1!4m6!3m5!1s0xd654dfeab896c8b:0x16dbcabc9b86e2e7!8m2!3d37.355004!4d-2.2961862";
export const WHATSAPP_URL = "https://wa.me/34661666916";
const MAP_EMBED = "https://maps.google.com/maps?q=Sobrino%20Sport%2C%20C%2F%20Granada%204%2C%20Olula%20del%20R%C3%ADo&z=16&output=embed";

const HOURS = [["Lunes a viernes", "10:00–13:45 · 17:00–20:30"], ["Sábados", "10:00–13:30"], ["Domingos", "Cerrado"]];

const Item = ({ icon: I, title, children }) => (
  <div className="flex gap-4 py-4 border-t first:border-t-0">
    <span className="w-10 h-10 shrink-0 rounded-full bg-brand/10 text-brand grid place-items-center"><I className="w-4 h-4" /></span>
    <div className="text-sm"><p className="font-bold">{title}</p>{children}</div>
  </div>
);

export const StoreInfo = () => (
  <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 mt-24" data-testid="home-store">
    <p className="eyebrow">Tienda física · Olula del Río</p>
    <h2 className="mt-2 font-heading text-3xl lg:text-5xl font-black uppercase tracking-tight">Ven a nuestra <span className="text-verde">tienda.</span></h2>
    <a href={MAPS_URL} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold hover:text-brand" data-testid="home-google-reviews">
      <span className="flex text-amber-400">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-4 h-4 fill-current" />)}</span> 4,7 en Google · 57 reseñas
    </a>
    <div className="mt-8 grid lg:grid-cols-12 gap-6">
      <div className="lg:col-span-4 bg-brand-dark text-white p-6" data-testid="home-store-hours">
        <p className="flex items-center gap-2 font-heading text-xl font-black uppercase"><Clock className="w-5 h-5 text-verde-light" /> Horario</p>
        {HOURS.map(([d, h]) => (
          <div key={d} className="py-3 border-b border-white/15 last:border-0"><p className="font-semibold">{d}</p><p className="text-sm text-white/75">{h}</p></div>
        ))}
      </div>
      <div className="lg:col-span-4 border px-5" data-testid="home-store-contact">
        <Item icon={MapPin} title="Dirección"><p className="text-slate-600">C/ Granada, 4 · Local 3<br />04860 Olula del Río (Almería)</p>
          <a href={MAPS_URL} target="_blank" rel="noreferrer" className="text-brand font-semibold inline-flex items-center gap-1 mt-1"><Navigation className="w-3 h-3" /> Cómo llegar</a></Item>
        <Item icon={Phone} title="Teléfono"><a href="tel:+34661666916" className="block text-slate-600 hover:text-brand">661 666 916</a><a href="tel:+34950443465" className="block text-slate-600 hover:text-brand">950 44 34 65</a></Item>
        <Item icon={Mail} title="Correo"><a href="mailto:sobrinosport@gmail.com" className="text-slate-600 hover:text-brand">sobrinosport@gmail.com</a></Item>
        <Item icon={MessageCircle} title="WhatsApp"><p className="text-slate-600">¿Buscas una oferta concreta?</p>
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="text-verde font-semibold" data-testid="home-whatsapp">Consultar por WhatsApp →</a></Item>
      </div>
      <iframe title="Mapa Sobrino Sport" src={MAP_EMBED} loading="lazy" className="lg:col-span-4 w-full min-h-[300px] border" data-testid="home-store-map" />
    </div>
  </section>
);

const WaIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.4.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3ZM12 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4A9.8 9.8 0 1 1 12 21.8Zm0-21.6A11.8 11.8 0 0 0 1.8 17.9L.2 23.8l6-1.6A11.8 11.8 0 1 0 12 .2Z" /></svg>
);

export const WhatsAppButton = () => {
  const { pathname } = useLocation();
  const busy = /^\/(producto|checkout|pedido)/.test(pathname);
  return (
    <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="Escríbenos por WhatsApp" data-testid="whatsapp-float"
      className={`fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white place-items-center shadow-lg hover:scale-105 transition-transform ${busy ? "hidden sm:grid" : "grid"}`}>
      <WaIcon className="w-7 h-7" />
    </a>
  );
};
